import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaTiktok } from 'react-icons/fa';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative text-white pt-20 pb-8 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
      <div className="absolute inset-0 opacity-20">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-teal-500 rounded-full mix-blend-multiply filter blur-xl animate-float"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl animate-float" style={{animationDelay: '2s'}}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Decorative Rule */}
        <div className="rule mb-12 border-white/20"></div>

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16">

          {/* Company Info & Contact */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <h3 className="text-2xl font-bold mb-2">Ravana Migration</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Your trusted partner for study abroad immigration services across Germany, Canada, Australia, UK, and New Zealand.
              </p>
            </div>

            {/* Contact Info */}
            <div className="space-y-4 mb-6">
              <div className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                  <FaPhone className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-xs text-gray-400">Call Us</p>
                  <a href="tel:+94112581181" className="text-sm">+94 11 258 1181</a>
                </div>
              </div>

              <div className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                  <FaEnvelope className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-xs text-gray-400">Email Us</p>
                  <a href="mailto:info@ravanaindustries.com" className="text-sm break-all">info@ravanaindustries.com</a>
                </div>
              </div>

              <div className="flex items-start gap-3 text-gray-300">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 mt-1">
                  <FaMapMarkerAlt className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-xs text-gray-400">Head Office</p>
                  <p className="text-sm">No 10/30/1/1, Pamankada Lane</p>
                  <p className="text-sm">Wellawatta, Colombo 06</p>
                  <p className="text-sm">Sri Lanka</p>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div>
              <h4 className="font-semibold text-sm mb-3 text-gray-200">Connect With Us</h4>
              <div className="flex flex-wrap gap-2">
                <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-300 hover:bg-white/10 hover:text-white hover:border-white/40 transition-all duration-300 group">
                  <FaFacebook size={18} />
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-300 hover:bg-white/10 hover:text-white hover:border-white/40 transition-all duration-300 group">
                  <FaInstagram size={18} />
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-300 hover:bg-white/10 hover:text-white hover:border-white/40 transition-all duration-300 group">
                  <FaLinkedin size={18} />
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-300 hover:bg-white/10 hover:text-white hover:border-white/40 transition-all duration-300 group">
                  <FaYoutube size={18} />
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-300 hover:bg-white/10 hover:text-white hover:border-white/40 transition-all duration-300 group">
                  <FaTiktok size={18} />
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-300 hover:bg-white/10 hover:text-white hover:border-white/40 transition-all duration-300 group">
                  <FaTwitter size={18} />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-tight font-semibold text-lg mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Home
              </Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Our Services
              </Link></li>
              <li><Link to="/pricing" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Pricing
              </Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                About Us
              </Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Contact Us
              </Link></li>
              <li><Link to="/choice" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Free Assessment
              </Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="heading-tight font-semibold text-lg mb-6 text-white">Our Services</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Study in Germany
              </Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Study in Canada
              </Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Study in Australia
              </Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Study in UK
              </Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Study in New Zealand
              </Link></li>
            </ul>
          </div>

          {/* Legal & Support */}
          <div>
            <h3 className="heading-tight font-semibold text-lg mb-6 text-white">Legal & Support</h3>
            <ul className="space-y-3 mb-6">
              <li><Link to="/privacy" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Privacy Policy
              </Link></li>
              <li><Link to="/refund" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Refund Policy
              </Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Terms & Conditions
              </Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-teal-400 transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1 h-1 rounded-full bg-teal-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                FAQ
              </Link></li>
            </ul>

            {/* Newsletter Signup */}
            <div className="bg-white/5 p-4 rounded-lg border border-white/10">
              <h4 className="font-semibold text-sm mb-2 text-white">Stay Updated</h4>
              <p className="text-xs text-gray-300 mb-3">Get the latest immigration updates and study abroad tips</p>
              <label htmlFor="footer-newsletter-email" className="sr-only">Email address</label>
              <div className="flex gap-2">
                <input
                  id="footer-newsletter-email"
                  name="newsletterEmail"
                  type="email"
                  autoComplete="email"
                  placeholder="Your email"
                  className="flex-1 px-3 py-2 bg-white/10 border border-white/20 rounded text-sm text-white placeholder-gray-400 focus:outline-none focus:border-teal-400"
                />
                <button className="px-4 py-2 bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white text-sm font-medium rounded transition-all duration-300 whitespace-nowrap">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
            <div className="text-center lg:text-left">
              <p className="text-sm text-gray-300">
                &copy; {currentYear} Ravana Industries Pvt Ltd. All rights reserved.
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Licensed Immigration Consultancy | Registration No: IMM-2024-001
              </p>
            </div>

            <div className="flex items-center gap-2 text-sm text-gray-300">
              <span>Made with</span>
              <span className="text-red-500 text-lg">❤️</span>
              <span>by Ravana Industries IT Solutions</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
